import { SelectType } from './models'
import { makeAutoObservable } from 'mobx'

interface ReportType {
	IsDelete: boolean
	date_insert: string
	date_update: Date | null
	date_viewed: Date | null
	groups: string
	id_faculty: number
	id_group: number
	id_oblast: number | null
	id_okno_document: number
	id_okno_zakaz: Number
	id_protocols: number
	id_raion: number | null
	id_republics: number | null
	id_student: number
	okno_document: string
	s_fio: string
	status: boolean
	EDS: boolean
	years: string
	ispolnitel: string
	status_new: boolean
}

class Report {
	reportTypes: SelectType[] = []
	reportExpected: ReportType[] = []
	currentType: number = 0

	constructor() {
		makeAutoObservable(this)
	}

	newReportTypes(param: SelectType[]) {
		this.reportTypes = param
	}

	newReport(param: ReportType[]) {
		this.reportExpected = param
	}

	newType(param: number) {
		this.currentType = param
	}
}

export const report = new Report()
